'use strict';

export const ApiConstants = Object.freeze({
  signIn: '/auth/login',
  signUp: '/auth/create-account',
  profileData: '/auth/profile',
  profileUpdate: '/auth/profile-update',
  verifyEmail: '/auth/verify-email',
  generateOtp: '/auth/generate-otp',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  changeEmail: '/auth/change-email',
  changePassword: '/auth/change-password',
  testimonials: '/settings/testimonial',
  listPlans: '/payment/list-plan',
  planDetail: '/payment/plan-detail',
  createPaymentIntent: '/payment/create-payment',
  inviteMember: '/company/invitation',
  companyEmployee: '/company/company-employee-list',
  redeemCode: '/assessment/redeem-assessment',
  responseDetail: '/assessment/response-detail',
  memberDetail: '/company/employee-detail',
  disableUser: '/company/disable-user',
  deleteUser: '/company/delete-user',
  submitAssessment: '/assessment/submit-assessment',
  sendAssessment: '/assessment/send-assessment',
  latestAssessment: '/assessment/latest-assessment',
  assessmentHistory: '/assessment/response',
  assessmentReview: '/assessment/assessment-review',
  bulkInvite: '/company/invite/bulk-user',
  externalResponseDetail: '/assessment/external-response-detail',
  externalSubmitAssessment: '/assessment/external-submit-assessment',
  appService: '/settings/app-service',
  requestService: '/settings/service-request',
  createTeam: '/company/create-team',
  listTeam: '/company/list-team',
  teamDetail: '/company/team',
  updateTeam: '/company/update-team',
  deleteTeam: '/company/team',
  updateCompany: '/company/update-company',
  addTeamStaff: '/company/add-team-members',
  removeTeamStaff: '/company/remove-team-members',
  changeRole: '/company/change-role',
  companyDetal: '/company/company',
  raiseRequest: '/company/raise-request',
  redeemCodeValidation: '/assessment/redeem-code-validation',
  invitationDetailByToken: '/auth/invitation-detail',
  observerList: '/assessment/observer',
  addMoreReviewer: '/assessment/invite-more-reviewer',
  userReport: '/report/user-report',
  teamReport: '/report/team-report',
  removeObserver: '/assessment/remove-reviewer',
  teamReportList: '/report/list-team-report',
  homeContent: '/settings/app-home-content',
  aboutContent: '/settings/app-about-content',
  assessmentContent: '/settings/app-assessment-content',
  footerContent: '/settings/app-footer-content',
  sendReminder: '/assessment/resend-observer-invitation',
  finalizeAssessment: "/assessment/finalize-assessment",
  employeeObserver: '/assessment/employee-observer',
  bookList:'/settings/app-book-content',
  resendEmail:'/company/resend-account-status-email',
  assessmentCodeStatus:"/assessment/free-assessment-code-status",
});
